import React, { useMemo } from "react";
import { Accordion, AccordionSet, MultiColumnList, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
var MDT_COLUMNS = [
    "rowNumber",
    "groupName",
    "books",
    "brochures",
    "total",
    "firstEdBooks",
    "firstEdBrochures",
    "firstEdTotal",
    "eTitles",
    "audioTitles",
];
var LANGUAGE_COLUMNS = [
    "languageCode",
    "languageName",
    "printedTotal",
    "printedLiterary",
    "eTotal",
    "eLiterary",
    "audioTotal",
    "audioLiterary",
];
export var Kult1501ReportResults = function (_a) {
    var data = _a.data;
    var _b = useIntl(), formatMessage = _b.formatMessage, formatNumber = _b.formatNumber;
    var mdtFormatter = useMemo(function () { return ({
        rowNumber: function (row) { return row.rowNumber; },
        groupName: function (row) { return row.groupName; },
        books: function (row) { return formatNumber(row.books); },
        brochures: function (row) { return formatNumber(row.brochures); },
        total: function (row) { return formatNumber(row.total); },
        firstEdBooks: function (row) { return formatNumber(row.firstEdBooks); },
        firstEdBrochures: function (row) {
            return formatNumber(row.firstEdBrochures);
        },
        firstEdTotal: function (row) { return formatNumber(row.firstEdTotal); },
        eTitles: function (row) { return formatNumber(row.eTitles); },
        audioTitles: function (row) { return formatNumber(row.audioTitles); },
    }); }, [formatNumber]);
    var languageFormatter = useMemo(function () { return ({
        languageCode: function (row) { return row.languageCode; },
        languageName: function (row) { return row.languageName; },
        printedTotal: function (row) {
            return formatNumber(row.printedTotal);
        },
        printedLiterary: function (row) {
            return formatNumber(row.printedLiterary);
        },
        eTotal: function (row) { return formatNumber(row.eTotal); },
        eLiterary: function (row) { return formatNumber(row.eLiterary); },
        audioTotal: function (row) { return formatNumber(row.audioTotal); },
        audioLiterary: function (row) {
            return formatNumber(row.audioLiterary);
        },
    }); }, [formatNumber]);
    var mdtColumnMapping = useMemo(function () { return ({
        rowNumber: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.rowNumber",
        }),
        groupName: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.groupName",
        }),
        books: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.books",
        }),
        brochures: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.brochures",
        }),
        total: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.total",
        }),
        firstEdBooks: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.firstEdBooks",
        }),
        firstEdBrochures: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.firstEdBrochures",
        }),
        firstEdTotal: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.firstEdTotal",
        }),
        eTitles: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.eTitles",
        }),
        audioTitles: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.audioTitles",
        }),
    }); }, [formatMessage]);
    var languageColumnMapping = useMemo(function () { return ({
        languageCode: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.languageCode",
        }),
        languageName: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.languageName",
        }),
        printedTotal: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.printedTotal",
        }),
        printedLiterary: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.printedLiterary",
        }),
        eTotal: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.eTotal",
        }),
        eLiterary: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.eLiterary",
        }),
        audioTotal: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.audioTotal",
        }),
        audioLiterary: formatMessage({
            id: "ui-br-legaldeposits.outputs.kult-15-01.column.audioLiterary",
        }),
    }); }, [formatMessage]);
    return (React.createElement("section", null,
        React.createElement("h3", null,
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.outputs.kult-15-01.results.title", values: { libraryName: data.libraryName, year: data.year } })),
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.outputs.kult-15-01.section.partI",
                }), open: true },
                React.createElement(MultiColumnList, { contentData: data.mdtRows, formatter: mdtFormatter, visibleColumns: MDT_COLUMNS, columnMapping: mdtColumnMapping, interactive: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.outputs.kult-15-01.section.partII",
                }) },
                React.createElement(MultiColumnList, { contentData: data.languageRows, formatter: languageFormatter, visibleColumns: LANGUAGE_COLUMNS, columnMapping: languageColumnMapping, interactive: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.outputs.kult-15-01.section.partIII",
                }) },
                React.createElement(MultiColumnList, { contentData: data.translationRows, formatter: languageFormatter, visibleColumns: LANGUAGE_COLUMNS, columnMapping: languageColumnMapping, interactive: false })))));
};
